/**
 * Modo vista previa: recorrer la app en local sin pasar por Azure AD y con
 * datos sembrados, para revisar diseno y pantallas.
 *
 * Solo se activa cuando la app corre en localhost, asi que ningun despliegue
 * puede quedar con esto prendido. Se enciende con ?preview=1 y se apaga con
 * ?preview=0.
 */
const PREVIEW_KEY = 'previewSinLogin';

export function esLocal(): boolean {
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export function enModoPreview(): boolean {
  if (!esLocal()) return false;

  const param = new URLSearchParams(window.location.search).get('preview');
  if (param === '1') sessionStorage.setItem(PREVIEW_KEY, '1');
  if (param === '0') sessionStorage.removeItem(PREVIEW_KEY);

  return sessionStorage.getItem(PREVIEW_KEY) === '1';
}
